import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DeviceService } from '../../services/device.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxPaginationModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent {
  constructor(
    public deviceService: DeviceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  public devices: any = [];
  public displayedDevices: any;
  public zones: any;
  public filterinfo: any;
  public selectedGroup: String = 'all';
  public keyword: String = '';
  public page: number = 1;
  public limit: number = 10;
  public totalPages: any;
  public totalRows: any;
  public maxVisiblePages: number = 5;
  public sortColumn: string = '';
  public sortOrder: string = 'ASC';
  public time_zone: String = Intl.DateTimeFormat().resolvedOptions().timeZone;

  ngOnInit(): void {
    this.initFilter();
    this.getAllZones();
    this.getAllDevices();
  }
  getAllZones() {
    this.deviceService.getAllZones().subscribe(
      (response) => {
        this.zones = response.data.zones;
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Dashboard');
        console.log('error message: ', error.error.message);
      }
    );
  }
  initFilter() {
    this.filterinfo = {
      keyword: '',
      page: this.page,
      limit: this.limit,
      sortColumn: '',
      sortOrder: 'ASC',
    };
  }
  getAllDevices() {
    this.spinner.show();
    this.filterinfo.page = this.page;
    this.filterinfo.limit = this.limit;
    this.filterinfo.sortColumn = this.sortColumn;
    this.filterinfo.sortOrder = this.sortOrder;
    if (this.selectedGroup != 'all') {
      this.filterinfo.group = this.selectedGroup;
      this.filterinfo.keyword = this.keyword;
    } else {
      this.filterinfo = {
        keyword: this.keyword,
        page: this.page,
        limit: this.limit,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
      };
    }
    this.deviceService.getAllDevices(this.filterinfo).subscribe(
      (response) => {
        this.devices = response.data.devices;
        this.totalRows = response.data.totalRows;
        this.totalPages = Math.ceil(this.totalRows / this.limit);
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Dashboard');
        console.log('error message: ', error.error.message);
        this.spinner.hide();
      }
    );
  }

  clearFilters() {
    this.selectedGroup = 'all';
    this.keyword = '';
    this.page = 1;
    this.sortColumn = '';
    this.sortOrder = 'ASC';
    this.initFilter();
    this.getAllDevices();
  }
  getDeviceDetails(id: any) {
    this.deviceService.setId(id);
    this.router.navigate(['/device/details']);
  }
  exportDevices() {
    this.spinner.show();
    this.filterinfo.page = this.page;
    this.filterinfo.limit = this.limit;
    this.filterinfo.sortColumn = this.sortColumn;
    this.filterinfo.sortOrder = this.sortOrder;

    if (this.selectedGroup != 'all') {
      this.filterinfo.group = this.selectedGroup;
      this.filterinfo.keyword = this.keyword;
      this.filterinfo.page = this.page;
      this.filterinfo.limit = this.limit;
      this.filterinfo.time_zone = this.time_zone;
    } else {
      this.filterinfo = {
        keyword: this.keyword,
        page: this.page,
        limit: this.limit,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
        time_zone: this.time_zone,
      };
    }
    this.deviceService.exportDevices(this.filterinfo).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], {
          //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          type: 'application/octet-stream',
        });
        saveAs(blob, 'devices.xlsx');
        this.toastr.success('Devices exported successfully', 'Dashboard');
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage);
        console.log('error message: ', error.error.message);
        this.spinner.hide();
      }
    );
  }
  pageChangeEvent(event: number) {
    this.spinner.show();
    this.page = event;
    this.getAllDevices();
  }
  Search() {
    this.page = 1;
    this.getAllDevices();
  }
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortColumn = column;
      this.sortOrder = 'ASC';
    }
    this.getAllDevices();
  }
}
